import {
    ProSkillAssureAssessmentDataModel
} from '~~/package/mapper/proSkillAssure/model/ProSkillAssureAssessmentDataModel';
import {UserStatusType} from '~~/package/mapper/user/model/UserStatusType';
import {ProSkillManagerType} from '~~/package/mapper/proSkillManager/model/ProSkillManagerType';

export const assureAssessmentInfo = {
    assessmentId: 0,
    assessmentTitle: "Sample Assessment",
    assessmentStatus: "LIVE",
    authorName: "codepresso",
    createdAt: "2026-01-01 00:00:00",
    userStatus: "NORMAL"
};

export const assureAssessmentData = {
    "type": "INTERNAL",
    "startedAt": "2026-01-01 00:00:00",
    "endedAt": "2030-12-31 00:00:00",
    "description": "Full Stack",
    "duration": 18000,
    "eyeTrackingFlag": true,
    "tabProctoringFlag": true,
    "copyPasteFlag": true,
    "shortcutFlag": true,
    "multiMonitorFlag": true,
    "screenRecordingFlag": true,
    "useExternalMonitoringFlag": false,
    "setList": [
        {
            "trackType": "CAREER",
            "trackLevelId": "874",
            "title": "Prompt Engineering for Developers",
            "description": "",
            "testTemplateList": [{ "id": 7147 }],
            "referenceUrl": "",
            "referenceUrlExposureFlag": false,
            "assessmentContentType": "AI_FLUENT",
            "assessmentSetInfoVO": {
                "trackId": 572,
                "trackLevelMapTestTemplateMapCustomAssessmentId": 0,
                "setsOrder": 1,
                "trackLevelTitle": "Beginner",
                "trackTitle": "Prompt Engineering for Developers",
                "taskCount": 4,
                "recommendTime": 7200
            }
        },
        {
            "trackType": "CAREER",
            "trackLevelId": "82",
            "title": "JavaScript",
            "description": "JavaScript",
            "testTemplateList": [{ "id": 5036 }],
            "referenceUrl": "",
            "referenceUrlExposureFlag": false,
            "assessmentContentType": "CORE",
            "assessmentSetInfoVO": {
                "trackId": 200001,
                "trackLevelMapTestTemplateMapCustomAssessmentId": 0,
                "setsOrder": 2,
                "trackLevelTitle": "Intermediate",
                "trackTitle": "JavaScript",
                "taskCount": 1,
                "recommendTime": 3600
            }
        }
    ],
    "modifyScope": "NONE",
    "creditPerCandidate": 1,
    "timeZoneId": "KR"
}

export const assureAssessmentList = {
    "data": [
        {
            "id": 0,
            "name": "codepresso",
            "userStatus": UserStatusType.NORMAL,
            "title": "Sample Assessment",
            "type": ProSkillManagerType.INTERNAL,
            "isEyeTracking": true,
            "isTabProctoring": true,
            "isCopyPasteFlag": true,
            "isShortcutFlag": true,
            "isMultiMonitorFlag": true,
            "isScreenRecordingFlag": true,
            "status": "LIVE",
            "candidateSummary": {
                "total": 3,
                "preStart": 1,
                "inProgress": 0,
                "completed": 2
            },
            "totalTime": 18000,
            "startedAt": "2026-01-01 00:00:00",
            "endedAt": "2030-12-31 00:00:00",
            "createdAt": "2026-01-01 00:00:00",
            "sets": [
                {
                    "trackId": 572,
                    "trackTitle": "Prompt Engineering for Developers",
                    "trackLevelTitle": "Beginner",
                    "setLearningTime": 0,
                    "setCount": 4,
                    "assessmentContentType": "AI_FLUENT"
                },
                {
                    "trackId": 200001,
                    "trackTitle": "JavaScript",
                    "trackLevelTitle": "Intermediate",
                    "setLearningTime": 0,
                    "setCount": 1,
                    "assessmentContentType": "CORE"
                }
            ],
            "noTimeLimit": false
        }
    ] as ProSkillAssureAssessmentDataModel[],
    "pageNumber": 1,
    "last": true,
    "totalElementCount": 1
};